import { apiClient } from '../../gateways/api'
import type { Opdracht } from '../types/Opdracht'

export { fetchOpdracht }

const fetchOpdracht = async (id: string): Promise<Opdracht> => {
  const { data } = await apiClient({
    url: `/rest/opdracht/deelnemer/${id}`,
    method: 'GET',
  })

  return data
}
